import { render, staticRenderFns } from "./mallPicture1.vue?vue&type=template&id=1f94081c&scoped=true"
import script from "./mallPicture1.vue?vue&type=script&lang=js"
export * from "./mallPicture1.vue?vue&type=script&lang=js"
import style0 from "./mallPicture1.vue?vue&type=style&index=0&id=1f94081c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f94081c",
  null
  
)

export default component.exports